import { currentWallet } from '@amply-app/wallet';
import { useMount } from 'react-use';

export const useInitializeWallet = () => {
  useMount(() => {
    currentWallet.autoConnect();
  });
};
